var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Tooltip } from '../../Tooltip';
import { CounterBody } from './CounterBody';
export var Counter = forwardRef(function (_a, ref) {
    var _b = _a.tooltipTitle, tooltipTitle = _b === void 0 ? '' : _b, rest = __rest(_a, ["tooltipTitle"]);
    var counterBody = React.createElement(CounterBody, __assign({}, rest, { ref: ref }));
    return (React.createElement(React.Fragment, null,
        tooltipTitle && React.createElement(Tooltip, { title: tooltipTitle }, counterBody),
        !tooltipTitle && counterBody));
});
